import { Pencil } from "lucide-react";
import { ConfirmDelete, EmptyState, GlassCard } from "@/components/erp";

export const trTarih = (s) => (s ? new Date(`${s}T00:00:00`).toLocaleDateString("tr-TR", { day: "2-digit", month: "long", year: "numeric", weekday: "short" }) : "—");
export const sayi = (v, d = 2) => Number(v || 0).toLocaleString("tr-TR", { maximumFractionDigits: d });

export const Tablo = ({ testid, cols, rows, yaz, onEdit, onDelete, bos = "Kayıt yok." }) => (
  <GlassCard className="overflow-x-auto erp-scroll">
    {rows.length === 0 ? <EmptyState text={bos} testid={`${testid}-bos`} /> : (
      <table className="w-full text-sm" data-testid={testid}>
        <thead><tr className="text-left text-[11px] uppercase tracking-wider text-muted-foreground border-b border-white/5">
          {cols.map(([l, , c]) => <th key={l} className={`p-3 whitespace-nowrap ${c || ""}`}>{l}</th>)}{yaz && <th className="p-3" />}
        </tr></thead>
        <tbody>{rows.map((r) => (
          <tr key={r.id} className={`border-b border-white/5 ${r.aktif === false || r.durum === "pasif" ? "opacity-50" : ""}`} data-testid={`${testid}-satir-${r.kod || r.id}`}>
            {cols.map(([l, fn, c]) => <td key={l} className={`p-3 ${c || ""}`}>{fn(r)}</td>)}
            {yaz && <td className="p-3 text-right whitespace-nowrap">
              <button data-testid={`${testid}-duzenle-${r.kod || r.id}`} onClick={() => onEdit(r)} className="p-2 rounded-lg text-muted-foreground hover:text-white"><Pencil className="w-4 h-4" /></button>
              <ConfirmDelete testid={`${testid}-sil-${r.kod || r.id}`} onConfirm={() => onDelete(r)} />
            </td>}
          </tr>
        ))}</tbody>
      </table>
    )}
  </GlassCard>
);
